/**
 * Affaire Detail API — New calls not covered by existing APIs
 */

import { apiClient } from '@/core/api/client';
import type { FicheBienCompletion } from '../types/affaire-detail.types';

const FM_BASE = '/api/fm/affaire';
const REVELO_BASE = '/api/revelo/v1/fiche';

/**
 * Get property data for an affaire
 */
export const getAffaireBiens = async (affaireId: string) => {
  return apiClient.get<{ success: boolean; data: { biens: any[] } }>(`${FM_BASE}/${affaireId}/biens`);
};

/**
 * Get documents for an affaire
 */
export const getAffaireDocuments = async (affaireId: string) => {
  return apiClient.get<{ success: boolean; data: any }>(`${FM_BASE}/${affaireId}/documents`);
};

/**
 * Get facade image metadata for an affaire
 */
export const getAffaireFacade = async (affaireId: string) => {
  return apiClient.get<{ success: boolean; data: { downloadUrl?: string; url?: string } }>(`${FM_BASE}/${affaireId}/facade`);
};

/**
 * Get fiche bien completion data
 */
export const getFicheBienCompletion = async (affaireId: string): Promise<{ success: boolean; data: FicheBienCompletion }> => {
  return apiClient.get<{ success: boolean; data: FicheBienCompletion }>(`${REVELO_BASE}/${affaireId}/completion`);
};

/**
 * Get fiche bien status
 */
export const getFicheBienStatus = async (affaireId: string) => {
  return apiClient.get<{ success: boolean; data: any }>(`${REVELO_BASE}/${affaireId}`);
};

export const affaireDetailAPI = {
  getAffaireBiens,
  getAffaireDocuments,
  getAffaireFacade,
  getFicheBienCompletion,
  getFicheBienStatus,
};
